import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function install(data = {}, query = {}) {
        return axios.post(`${endpoint}/install`, data, { params: query, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        install
    }
}

export default service
